import React from 'react'
import { makeStyles } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import ChartCatalogMenu from './ChartCatalogMenu'

// Last item in the chart stack: a dashed-border placeholder tile that
// opens the chart catalog menu. Uses ChartCatalogMenu's `renderTrigger`
// hook so the catalog state (saved / eligible / disabled) stays in one
// place and matches the toolbar's `Charts` menu exactly.

const useStyles = makeStyles(() => ({
  tile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flexShrink: 0
  },
  trigger: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    width: '100%',
    minHeight: 96,
    padding: '20px 16px',
    background: 'transparent',
    border: '1.5px dashed var(--color-neutral-300, #d1d5db)',
    borderRadius: 'var(--border-radius-md, 6px)',
    color: 'var(--color-neutral-500, #6b7280)',
    fontSize: 13,
    fontWeight: 'var(--font-weight-medium, 500)',
    cursor: 'pointer',
    transition: 'border-color 120ms ease, background-color 120ms ease, color 120ms ease',
    '&:hover': {
      borderColor: 'var(--color-primary-400, #3a83f5)',
      background: 'var(--color-primary-50, #f0f7ff)',
      color: 'var(--color-primary-700, #1557b0)'
    },
    '&:focus-visible': {
      outline: '2px solid var(--color-primary-400, #3a83f5)',
      outlineOffset: 2
    }
  },
  triggerOpen: {
    borderColor: 'var(--color-primary-400, #3a83f5)',
    background: 'var(--color-primary-50, #f0f7ff)',
    color: 'var(--color-primary-700, #1557b0)'
  },
  triggerDisabled: {
    cursor: 'default',
    opacity: 0.55,
    '&:hover': {
      borderColor: 'var(--color-neutral-300, #d1d5db)',
      background: 'transparent',
      color: 'var(--color-neutral-500, #6b7280)'
    }
  },
  iconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    background: 'var(--color-neutral-100, #f3f4f6)',
    color: 'inherit'
  },
  label: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: 6
  },
  hint: {
    fontSize: 11,
    color: 'var(--color-neutral-400, #9ca3af)',
    fontWeight: 400
  }
}))

export default function AddChartTile () {
  const classes = useStyles()

  return (
    <div className={classes.tile}>
      <ChartCatalogMenu
        renderTrigger={({ isOpen, disabled, onOpen }) => {
          const className = [
            classes.trigger,
            isOpen ? classes.triggerOpen : '',
            disabled ? classes.triggerDisabled : ''
          ].filter(Boolean).join(' ')
          return (
            <button
              type='button'
              className={className}
              onClick={disabled ? undefined : onOpen}
              aria-haspopup='menu'
              aria-expanded={isOpen}
              aria-disabled={disabled ? 'true' : 'false'}
              title={disabled ? 'Add measure columns to enable charts' : 'Add a chart'}
            >
              <span className={classes.iconWrap} aria-hidden='true'>
                <AddIcon style={{ fontSize: 16 }} />
              </span>
              <span className={classes.label}>
                <span>Add chart</span>
                <span className={classes.hint}>from catalog</span>
              </span>
            </button>
          )
        }}
      />
    </div>
  )
}
